export default __webpack_public_path__ + "353dca0.png";